import { Channel, ChannelGroupingResult, ChannelType } from "./channelgrouping";
import { ParsedUrlParams } from "./urlparams";
import { Utms } from "./utms";

/**
 * Social channel detection
 * 
 * This is a list of social media platforms that are commonly used.
 */
const platforms : Array<string> = [
    'facebook',
    'twitter',
    // use leading slashes to indicate that
    // we don't want to match on a partial domain match
    // (for these shorter domain names)
    '/x.com', // x aka twitter
    '/t.co', // x aka twitter tracking proxy domain (outbound links)
    'linkedin',
    'instagram',
    'pinterest',
    'tiktok',
    'snapchat',
];


export default class SocialChannel {

    public static utmSources: string[] = [
        'facebook',
        'instagram',
        'twitter',
    ];

    public static is(referrer: string, params: ParsedUrlParams) : ChannelGroupingResult |  null
    {

        // first, check referrer for hints at an organic social referral
        for (let i = 0; i < platforms.length; i ++) {
            const platformName = platforms[i];
            if (referrer.indexOf(platformName) !== -1) {
                return new ChannelGroupingResult(Channel.Social, ChannelType.Other);
            }
        }

        // next, look for utm source hints
        const utms = new Utms(params);
        const source = utms.getSource();
        if (source) {
            if (SocialChannel.utmSources.indexOf(source.toLowerCase().trim()) !== -1) {
                return new ChannelGroupingResult(Channel.Social, ChannelType.Other);
            }
        }
        return null;
    }

}
